<template lang="html">
  <div class="actions" :class="type">


    <button class="button is-white" v-scroll-to="'#add-to-shopping-list'" @click="$root.$emit('openShoppingSelection')" v-if="showShopping">
      <b-icon icon="shopping-basket" type="is-primary"/>
    </button>

    <button class="button is-white" v-scroll-to="'#comment'" @click="$root.$emit('openCommentForm')" v-if="showComment">
      <b-icon icon="comment" type="is-primary"/>
    </button>


    <a :href="documentUrl" target="_blank" class="button is-white" v-if="documentUrl">
      <b-icon icon="print" type="is-primary"/>
    </a>
    <print-recipe v-else-if="showPrint">
      <button class="button is-white">
        <b-icon icon="print" type="is-primary"/>
      </button>
    </print-recipe>


    <div class="horizontal-line" v-if="showSharing && (showPrint || showComment || showShopping)"/>

    <template v-if="showSharing">
      <a class="button is-white" data-social="facebook" :data-title="title" :data-image="image" :data-description="description">
        <b-icon icon="facebook" type="is-facebook"/>
      </a>

      <a class="button is-white is-hidden-tablet" data-social="whatsapp" :data-title="title" :data-image="image" :data-description="description">
        <b-icon icon="whatsapp" type="is-whatsapp"/>
      </a>

      <a class="button is-white" data-social="twitter" :data-title="title" :data-image="image" :data-description="description">
        <b-icon icon="twitter" type="is-twitter"/>
      </a>

      <a class="button is-white" data-social="pinterest" :data-title="title" :data-image="image" :data-description="description">
        <b-icon icon="pinterest" type="is-pinterest"/>
      </a>

      <b-dropdown position="is-top-left">
        <button class="button is-white" slot="trigger">
          <b-icon icon="ellipsis-h" type="is-primary"/>
        </button>

        <b-dropdown-item has-link>
          <a data-social="vkontakte" :data-title="title" :data-image="image" :data-description="description">
            <b-icon icon="vk" type="is-vk"/> VKontakte
          </a>
        </b-dropdown-item>

        <b-dropdown-item has-link>
          <a :href="`mailto:?subject=${title}&body=${description}  ${url}`">
            <b-icon icon="envelope-o"/> E-Mail
          </a>
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </div>
</template>

<script>
import PrintRecipe from 'shared/components/recipe/Print.vue'

export default {
  props: {
    title: {type: String, required: true},
    description: {type: String, default: ''},
    image: {type: String, defalt: null},
    type: {type: String, default: ''},
    showSharing: {
      type: Boolean,
      default: false
    },
    showPrint: {
      type: Boolean,
      default: false
    },
    showComment: {
      type: Boolean,
      default: false
    },
    showShopping: {
      type: Boolean,
      default: true
    },
    recipeId: {type: [Number, String], default: 0},
    language: {type: String, default: 'de_at'}
  },

  data(){
    return {
      servingCount: 0
    }
  },

  created(){
    this.$root.$on('serving_count_change', value => {
      this.servingCount = value
    })
  },

  components: {
    PrintRecipe
  },

  computed: {
    url(){
      return window.location.href
    },

    documentUrl(){
      if(window.__INIT_DATA && window.__INIT_DATA.recipe && window.__INIT_DATA.recipe.documents){
        const docs = window.__INIT_DATA.recipe.documents
        const document = docs.find(doc => {
          const opts = doc.options
          return opts.image && opts.columns === 2 && opts.language === this.language
        })
        if(document) return `${window.location.href}?document=${document.id}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.actions{
  display: flex;
  justify-content: center;
  margin-bottom: -15px;

  &.is-right{
    justify-content: flex-end;
    margin-right: -15px;
  }

  .horizontal-line {
    border-left: 1px solid #ededed;
    margin: 5px 2px;
  }
}

@media print{
  .actions{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserActions.vue